import Vue from 'vue';
import store from './store/index';
import AuthHolder from './AuthHolder.vue';
import { getRestoreToken } from './utils';

const searchParams = new URLSearchParams(window.location.search);
const objDirectory = document.querySelector('[data-dir-ui]');
const directory = objDirectory ? objDirectory.getAttribute('data-dir-ui') : 'consumer';
const roleAuthorized = document.querySelector('[data-role-authorized]');
const isRoleAuthorized = roleAuthorized ? !!roleAuthorized.getAttribute('data-role-authorized') : false;

export default (el) => {
  const openAuth = document.querySelectorAll('[data-open-auth-ui]');
  if (openAuth && openAuth.length) {
    openAuth.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        if (item.dataset.addGetParamCheck) {
          window.history.pushState(null, null, '?check');
        }

        if (!isRoleAuthorized) {
          let detail = {};

          if (item.getAttribute('data-open-auth-ui') === 'reload') {
            detail = { callback: () => { window.location.reload(); } };
          }

          if (item.getAttribute('data-link-open-auth-ui')) {
            detail = {
              callback: () => {
                window.location.href = item.getAttribute('data-link-open-auth-ui');
              }
            };
          }

          const event = new CustomEvent('auth:show', { detail });
          document.dispatchEvent(event);
        }
      });
    });
  }

  const regAuth = document.querySelectorAll('[data-open-reg-auth-ui]');
  if (regAuth && regAuth.length) {
    regAuth.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();

        if (!isRoleAuthorized) {
          document.dispatchEvent(new CustomEvent('auth:reg'));
        }
      });
    });
  }

  window.authInstance = new Vue({
    el,
    store,
    data() {
      return {
        successAuthCallback: () => {
          window.location.reload();
        },
        successRegisterCallback: (url) => {
          if (url) {
            window.location.href = url;
          }
        }
      };
    },
    mounted() {
      const authEshop = document.querySelector('[data-eshop-auth-trigger]');
      if (authEshop) {
        authEshop.setAttribute('data-init-eshop-auth-trigger', '');
      }
    },
    render: (h) => h(AuthHolder, {
      props: {
        typeAuth: directory
      }
    })
  });

  if (searchParams.has('auth') && !isRoleAuthorized) {
    document.dispatchEvent(new CustomEvent('auth:show'));
  }

  if (searchParams.has('reg') && !isRoleAuthorized) {
    document.dispatchEvent(new CustomEvent('auth:reg'));
  }

  if (getRestoreToken()) {
    document.dispatchEvent(new CustomEvent('auth:showRestorePassword'));
  }
};
